import React from "react";
import { CCard, CCardBody, CCardHeader } from "@coreui/react";

const TermsAndConditions = () => {
  return (
    <div className="privacy-page">
      <CCard className="privacy-card">
        <CCardHeader className="privacy-header">
          <h2>EZYBUY – Terms and Conditions</h2>
          <small>Effective Date: 02-08-2025</small>
        </CCardHeader>

        <CCardBody className="privacy-body">
          <p>
            These Terms and Conditions (“Terms”) govern your access to and use
            of the EZYBUY mobile application (“App”) and services (“Services”)
            provided by Conjoinix Total Solution Private Limited, a company
            incorporated under the Companies Act, 2013, with its Registered
            Office at Jodhamal Colony, Near Holy Heart School, Dhangu Road,
            Pathankot, Punjab – 145001, and Corporate Office at Sector 34A,
            Chandigarh(&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or
            &quot;our&quot;).
          </p>

          <p>
            By accessing or using the EZYBUY App, you agree to be bound by these
            Terms. If you do not agree, please do not use the App.
          </p>

          <h4>1. No Involvement in Commercial Transactions</h4>
          <ul>
            <li>
              EZYBUY is not a party to any transaction between the
              store/business and the customer.
            </li>
            <li>
              We do not control, verify, approve, or guarantee the quality,
              price, delivery, safety, or legality of any product or service
              offered through the websites hosted on EZYBUY.
            </li>
            <li>
              All payments for goods and services must be made directly to the
              store/business owner, not to EZYBUY or Conjoinix Total Solution
              Private Limited.
            </li>
            <li>
              We do not issue receipts, invoices, or bills on behalf of any
              business.
            </li>
            <li>
              The business owner is solely responsible for fulfilling orders,
              issuing refunds, and handling customer service.
            </li>
          </ul>

          <h4>2. Account and Access</h4>
          <ul>
            <li>
              Some features may require account creation. You are responsible
              for keeping your login credentials secure.
            </li>
            <li>
              You must be at least 18 years of age or the age of legal majority
              in your jurisdiction to use the App independently.
            </li>
            <li>
              If you represent a business using EZYBUY, you must have legal
              authority to bind your business to these Terms.
            </li>
          </ul>

          <h4>3. Business User Responsibilities</h4>
          <ul>
            <li>
              Provide accurate information about your products, services,
              prices, delivery timelines, and refund policies.
            </li>
            <li>
              Comply with all applicable local, state, and central laws,
              including tax, licensing, food safety, and consumer protection
              laws.
            </li>
            <li>
              Handle all customer orders, deliveries, payments, and complaints
              independently.
            </li>
            <li>
              Acknowledge that EZYBUY is not your agent, partner, or franchise
              holder, and does not share liability for your actions or
              omissions.
            </li>
          </ul>

          <h4>4. Platform Usage Rules</h4>
          <ul>
            <li>Upload illegal, obscene, fraudulent, or harmful content.</li>
            <li>Attempt to reverse engineer, hack, or disrupt the App.</li>
            <li>Use the App to impersonate any other person or business.</li>
            <li>
              Use bots, scrapers, or automated tools to access or misuse the
              App.
            </li>
          </ul>
          <p>
            Violation of these rules may result in termination of access and
            legal action.
          </p>

          <h4>5. Intellectual Property</h4>
          <ul>
            <li>
              All software, content design, and infrastructure of EZYBUY are the
              intellectual property of Conjoinix Total Solution Private Limited.
            </li>
            <li>
              You may not use our trademarks, logos, or copyrighted material
              without prior written consent.
            </li>
            <li>
              Businesses retain ownership of their respective product images,
              brand names, and descriptions.
            </li>
          </ul>

          <h4>6. Limitation of Liability</h4>
          <p>To the maximum extent allowed by law:</p>
          <ul>
            <li>
              EZYBUY and Conjoinix Total Solution Private Limited shall not be
              liable for any loss, damage, or dispute arising from transactions
              between customers and stores/businesses.
            </li>
            <li>
              Quality, accuracy, or timeliness of goods or services sold through
              hosted websites.
            </li>
            <li>Business decisions made by the vendors.</li>
            <li>
              Third-party payment failures, delivery delays, or acts of God.
            </li>
          </ul>

          <h4>7. Termination of Access</h4>
          <p>
            We reserve the right to suspend or terminate your access to the App
            or Services if:
          </p>
          <ul>
            <li>You violate these Terms</li>
            <li>Required by law or regulatory authorities</li>
            <li>
              In our judgment, your actions harm EZYBUY, its users, or the
              general public
            </li>
          </ul>

          <h4>8. Updates to Terms</h4>
          <p>
            We may revise these Terms from time to time. Any material changes
            will be notified within the App or via email.
          </p>
          <p>
            Continued use of the App after such notice constitutes acceptance of
            the updated Terms.
          </p>

          <h4>9. Governing Law and Jurisdiction</h4>
          <p>
            These Terms are governed by the laws of India. All disputes shall be
            subject to the exclusive jurisdiction of the courts at Chandigarh,
            India.
          </p>

          <h4>10. Customer Complaints Disclaimer</h4>
          <p>
            EZYBUY is a technology platform that provides website and IT
            services to departmental stores, confectionery stores, restaurants,
            and other business enterprises.
          </p>
          <p>
            EZYBUY does not entertain or resolve customer complaints regarding
            any product or service purchased through the platform.
          </p>
          <p>
            All complaints, disputes, refund requests, or issues must be
            addressed directly to the respective store or business.
          </p>

          <h4>12. Indemnity</h4>
          <p>
            You agree to indemnify, defend, and hold harmless EZYBUY, Conjoinix
            Total Solution Private Limited, and its directors, officers,
            employees, affiliates, and agents from any claims, liabilities,
            damages, or expenses arising out of:
          </p>
          <ul>
            <li>Your use of the EZYBUY platform or services</li>
            <li>Any breach of laws by you or your business</li>
            <li>
              Any content, product, or service offered by your store or website
            </li>
            <li>Any dispute between you and your customers or third parties</li>
          </ul>

          <p>
            This clause shall survive the termination or expiration of these
            Terms.
          </p>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default TermsAndConditions;
